import { render, staticRenderFns } from "./Manage-Companydepartment.vue?vue&type=template&id=4f8e9350"
import script from "./Manage-Companydepartment.vue?vue&type=script&lang=js"
export * from "./Manage-Companydepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports